import { type FAQItem, FAQTypeValue, type SuggestedEntry } from '../copied/models/ChatModules';
import makeApi from './api';

export function getImageItem(result: SuggestedEntry) {
  return result.render_json?.find((item: FAQItem) => item?.reg_id?._type_val === FAQTypeValue.Image);
}

export function getVideoItem(result: SuggestedEntry) {
  return result.render_json?.find((item: FAQItem) => item?.reg_id?._type_val === FAQTypeValue.Video);
}

export function checkIsExternalLinkWithImage(result: SuggestedEntry) {
  return !!(result.external_link && getImageItem(result));
}

export default async function fetchSearchResults({
  uuid,
  search,
  suggested,
  category,
}: {
  uuid?: string;
  search?: string;
  suggested?: boolean;
  category?: string;
}) {
  const params: {
    search_text?: string;
    suggested?: boolean;
    category?: string;
  } = {};

  if (search) {
    params.search_text = search;
  } else {
    params.suggested = suggested ?? true;
  }

  if (category) {
    params.category = category;
  }

  const api = makeApi();
  const response = await api.get(`/api/v1/web_chat/v3.0/help-center/${uuid}/knowledgebase/`, {
    params,
  });

  return response.data;
}
